<template>
  <div class="comp-profile" :class="{ me: itsMe }">
    <div class="profile-container">
      <!-- Relationship 표시 -->
      <div
        class="relationship"
        :class="{
          undefined: relUndefined,
          type1: relType1,
          type2: relType2,
          type3: relType3,
          type4: relType4
        }"
      ></div>

      <div class="form-container" v-if="diconnectUser">
        <input
          type="checkbox"
          name="select-user"
          :id="selectedId"
          v-model="checked"
          :value="selectedId"
          @change="updateValue($event.target.value)"
        />
        <label :for="selectedId">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            class="checked"
          >
            <polyline points="9 11 12 14 22 4"></polyline>
            <path
              d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"
            ></path>
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            class="unchecked"
          >
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
          </svg>
        </label>
      </div>
      <!-- 프로필 사진 -->
      <div
        class="photo"
        :class="{
          me: itsMe,
          selectable: masterGrantMode && !isMaster,
          selected: isMasterCandidate && !isMaster
        }"
        :style="updatePhotoView()"
      >
        <span class="master" v-if="!btnRooms && isMaster"></span>
      </div>

      <!-- 유저 이름, 타입 -->
      <div class="name-field">
        <div class="name" :class="{ me: itsMe }">
          {{ profileName }}
        </div>
        <div class="name-sub">{{ profileSub }}</div>
      </div>

      <!-- 버튼 그룹 -->
      <div class="buttons" v-if="hasButton && !masterGrantMode">
        <div class="set rooms" v-if="btnRooms">
          <div class="btn" v-if="userAdmin" @click.stop="$emit('admin-click')">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </div>
          <div class="btn" v-else @click.stop="$emit('user-click')">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16 17 21 12 16 7"></polyline>
              <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
          </div>
        </div>

        <div class="set invite-sent" v-if="btnInviteSent">
          <div class="btn highlight" @click.stop="$emit('resend')">Resend</div>
          <div class="btn" @click.stop="$emit('dismiss')">Dismiss</div>
        </div>

        <div class="set invite-received" v-if="btnInviteReceived">
          <div class="btn" @click.stop="$emit('acceptReceived')">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </div>
          <div class="btn delete" @click.stop="$emit('deleteReceived')">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </div>
        </div>

        <div class="set invite-received" v-if="btnRoomSpecific">
          <div
            class="btn delete"
            v-if="isAdmin && isMaster"
            @click.stop="$emit('delete-click')"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </div>
          <div class="btn" v-if="invitePending == 'pending'">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              class="pending"
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="8.5" cy="7" r="4"></circle>
              <line x1="20" y1="8" x2="20" y2="14"></line>
              <line x1="23" y1="11" x2="17" y2="11"></line>
            </svg>
          </div>
          <div
            class="btn"
            v-else-if="invitePending == 'none'"
            @click="onInviteClick"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="8.5" cy="7" r="4"></circle>
              <line x1="20" y1="8" x2="20" y2="14"></line>
              <line x1="23" y1="11" x2="17" y2="11"></line>
            </svg>
          </div>
        </div>
      </div>

      <!-- Change master buttons -->
      <div class="buttons">
        <div class="set invite-sent" v-if="isAdmin && isMaster">
          <div
            class="btn highlight"
            v-if="!masterGrantMode"
            @click.stop="$emit('mgm-on')"
          >
            Administrator
          </div>
          <div class="btn" v-else @click.stop="$emit('mgm-off')">Cancel</div>
        </div>
        <div class="set invite-sent" v-if="isMasterCandidate">
          <div class="btn highlight" @click.stop="$emit('mgm-modal')">
            Administrator
          </div>
        </div>
      </div>
    </div>

    <div class="profile-add" v-if="viaRoom">
      <span>via '{{ viaRoom }}'</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompProfile',
  props: {
    itsMe: Boolean,
    diconnectUser: Boolean,
    photoImage: String,
    profileName: String,
    profileSub: String,
    relUndefined: Boolean,
    relType1: Boolean,
    relType2: Boolean,
    relType3: Boolean,
    relType4: Boolean,
    viaRoom: Boolean,
    hasButton: Boolean,
    btnRooms: Boolean,
    btnInviteSent: Boolean,
    btnInviteReceived: Boolean,
    btnRoomSpecific: Boolean,
    userAdmin: Boolean,
    invitePending: String,
    selectedId: Number,
    isAdmin: Boolean,
    isMaster: Boolean,
    roomMasterPartnerSeqId: Number,
    masterGrantMode: Boolean,
    isMasterCandidate: Boolean
  },
  data() {
    return {
      checked: []
    }
  },
  methods: {
    updatePhotoView() {
      if (this.photoImage) {
        return {
          backgroundImage: `url(data:image/png;base64,${this.photoImage})`
        }
      }
    },
    updateValue(checked) {
      this.$emit('checkedParent', checked)
    },
    onInviteClick() {
      this.$emit('invite-click')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" src="../scss/comp-profile.scss" scoped></style>
